export default __webpack_public_path__ + "static/media/Motor.14134d24.webp";